import { useEffect, useState, useSyncExternalStore } from 'react';
import {
    isPasswordRecoveryPending,
    PASSWORD_RECOVERY_CLEARED_EVENT,
    PASSWORD_RECOVERY_PENDING_EVENT,
} from '../utils/passwordRecoveryPending';
import { hasRecoveryCallbackParams } from '../utils/recoverySession';

function subscribe(callback: () => void) {
    window.addEventListener(PASSWORD_RECOVERY_PENDING_EVENT, callback);
    window.addEventListener(PASSWORD_RECOVERY_CLEARED_EVENT, callback);
    return () => {
        window.removeEventListener(PASSWORD_RECOVERY_PENDING_EVENT, callback);
        window.removeEventListener(PASSWORD_RECOVERY_CLEARED_EVENT, callback);
    };
}

function isResetPasswordPath(pathname: string): boolean {
    return pathname === '/reset-password' || pathname === '/password-reset';
}

function getRecoveryLockedSnapshot(): boolean {
    const pathname = window.location.pathname;
    const hasCallbackParams = hasRecoveryCallbackParams();

    // Stale sessionStorage must not block /login or / — only lock during an active reset flow.
    if (!isResetPasswordPath(pathname) && !hasCallbackParams) {
        return false;
    }

    return isPasswordRecoveryPending() || hasCallbackParams;
}

/** True while password reset must complete before any other app surface is shown. */
export function useRecoveryLocked(): boolean {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    const locked = useSyncExternalStore(subscribe, getRecoveryLockedSnapshot, () => false);

    // Match server render (false) until mounted to avoid a blank hydration mismatch.
    return mounted && locked;
}
